module.exports = __webpack_public_path__ + "img/img16.92b4a39b.svg";